module.exports = __webpack_public_path__ + "static/media/ForgotPasswordPage.d41d8cd9.scss";


//////////////////
// WEBPACK FOOTER
// ./src/modules/onboarding/pages/forgot-password/ForgotPasswordPage.scss
// module id = 179
// module chunks = 0